import Subheading from '@/components/Subheading';
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';
import FormGroup from '@/components/FormGroup';
import {FormMessage} from '@/components/containers/my-account/utils/form-message';
import {UserApi} from '@/api/user';
import set from 'lodash/set';
import isArray from 'lodash/isArray';

const UserAccountBase = {
  components: {Heading, SectionHeader, Subheading, FormGroup},
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  mixins: [FormMessage],
  computed: {
    api() {
      return UserApi;
    },
  },
  methods: {
    /**
     * Handle cancel button click.
     */
    cancel() {
      window.location.href = this.options.cancelUrl;
    },

    /**
     * Handle form submission.
     * @return {Promise<void>}
     */
    submit() {
      this.hideMessage();
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.processUpdate();
        }
      });
    },

    /**
     * Process update method (to be implemented in children component).
     * @return {Promise<void>}
     */
    async processUpdate() {
      console.error('processUpdate method not implemented.');
    },

    /**
     * A helper method to set specific error messages for password confirmation field (different than what vee-validate provides by default).
     * @param options
     */
    useCustomPasswordValidationMessages(options) {
      let dictionary = {};
      if (!options) {
        return;
      }

      /**
       * An internal helper to make sure that overridden error messages always end with a dot.
       * @param property
       * @return {string}
       */
      const bp = (property) => {
        let result = this.bp(property);
        return `${result}${result.endsWith('.') ? '' : '.'}`;
      };

      if ('passwordField' in options) {
        (!isArray(options.passwordField) ? [options.passwordField] : options.passwordField).forEach((field) => {
          set(dictionary, `custom.${field}`, {
            required: bp('trek.pwd.empty'),
          });
        });
      }

      if ('passwordConfirmationField' in options) {
        set(dictionary, `custom.${options.passwordConfirmationField}`, {
          confirmed: bp('validation.checkPwd.equals'),
          required: bp('updatePwd.checkPwd.invalid'),
        });
      }

      this.$validator.localize(this.$store.state.vvLocale, dictionary);
    },
  },
  data() {
    return {
      isWorking: false,
    };
  },
};

export {UserAccountBase};
